let LoaderSize = /*#__PURE__*/function (LoaderSize) {
  LoaderSize["Small"] = "small";
  LoaderSize["Medium"] = "medium";
  LoaderSize["Large"] = "large";
  return LoaderSize;
}({});

export { LoaderSize };
//# sourceMappingURL=loader-size.js.map
